<template lang="pug">
div
  | {{ value }}
</template>
<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, watch, nextTick } from 'vue'
import { useRogue } from '@/js/services/Rogue'

const props = defineProps<{value: number, type: 'currency' | 'number', currency?: string, durationMs?: number}>()

const pctComplete = ref(0)
const startTime = ref(Date.now())
const rogue = useRogue()

function easeOutCubic(x: number): number {
  return 1 - ((1 - x) ** 3)
}

function nextFrame() {
  nextTick(() => {
    const pct = ((Date.now() - startTime.value) / (props.durationMs || 750)) * 100
    pctComplete.value = Math.min(pct, 100)

    if (pctComplete.value < 100) {
      setTimeout(() => nextFrame(), 25)
    }
  })
}

function reset() {
  pctComplete.value = 0
  startTime.value = Date.now()
  nextFrame()
}

watch(() => props.value, () => reset())

onMounted(() => reset())

const value = computed(() => {
  const val = props.value * easeOutCubic(pctComplete.value / 100)

  if (props.type === 'currency') {
    return rogue.currency(val, { currency: props.currency || 'USD' })
  }

  return val.toLocaleString()
})

</script>
